import { render, staticRenderFns } from "./ActionPanewsChangeImg.vue?vue&type=template&id=5d67fac4&scoped=true&"
import script from "./ActionPanewsChangeImg.vue?vue&type=script&lang=js&"
export * from "./ActionPanewsChangeImg.vue?vue&type=script&lang=js&"
import style0 from "./ActionPanewsChangeImg.vue?vue&type=style&index=0&id=5d67fac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67fac4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VIcon,VSpacer})
